class TiedProduct extends HTMLElement {
  constructor() {
      super()
      this.colorSwatchesOptions = ["Color","Ribbon color","Background Color","Ribbon Color"]
      this.builder = this.closest('product-main-builder');
      this.mainProductData = this.builder.productData;
      this.tiedProductData = JSON.parse(this.querySelector('[type="application/json"][data-tied-product-json]').textContent);
      this.tmpVariants = this.tiedProductData.variants;
      this.fakeVariantTitle = this.dataset.fakeVariantTitle;
      this.fakeVariantStartAt = parseInt(this.dataset.fakeVariantStartAt);
      this.mainGallery = this.builder.querySelector('product-gallery');
      this.mainGalleryThumbs = this.builder.querySelector('product-thumbs');
      this.hideVariantNameSuffix = this.dataset.hideVariantNameSuffix;
      
      if (this.fakeVariantTitle && this.fakeVariantStartAt) {
        var firstVariant = this.tiedProductData.variants[0];
        var firstVariantOption = firstVariant.option1;
        var fakeVariantId = this.fakeVariantStartAt;
        var fakeVariantTitle = this.fakeVariantTitle;
        this.tiedProductData = {
          ...this.tiedProductData,
          variants: [
            ...this.tiedProductData.variants.map(variant => {
              var mappedVariant = null;
              if (variant.option1 === firstVariantOption) {
                mappedVariant = {
                  ...variant,
                  id: fakeVariantId,
                  option1: this.fakeVariantTitle,
                  title: variant.title.replace(firstVariantOption, fakeVariantTitle),
                  name: variant.name.replace(firstVariantOption, fakeVariantTitle),
                  public_title: variant.public_title.replace(firstVariantOption, fakeVariantTitle),
                  options: variant.title.replace(firstVariantOption, fakeVariantTitle).split('/').map(x => x.trim())
                }
              };
              fakeVariantId = fakeVariantId - 1;
              return mappedVariant
            }).filter(x => x),
            ...this.tiedProductData.variants
          ]
        }
      }
      
      this.variantInput = this.querySelector('.single-option-selector');
      this.options = this.tiedProductData.options.filter(option=>!this.mainProductData.options.includes(option));
      this.commonOptions = this.tiedProductData.options.filter(option=>this.mainProductData.options.includes(option));
      this.optionValues = {};
      this.label = this.dataset.label;
      
      this.buildOptionsSelectors();
      this.optionsElements = this.querySelectorAll('[data-option]');
      this.bindOptions();

      this.builder.addEventListener('mainVariantChange', (e)=>{

          if(this.tiedProductData.productOptionTied){
            this.toggleComponent(e.detail.variant);
          }

          var matchingVariant = this.getMatchingVariant(e.detail.variant);
          var variant = matchingVariant[0];
          
          this.refreshComponent(variant, true);

      });
  }

  toggleComponent(variant){
    let found = false;
    this.tiedProductData.productOptionTied.forEach(option => {
      if(variant[option.option] && variant[option.option] == option.value){
        found = true;
      }
    });
    
    if(found){
      this.classList.remove('hide');
      this.querySelectorAll('.step').forEach(step => {
        step.removeAttribute('data-not-required')
        step.classList.remove('no-step');
      });
      this.builder.updateStepsData();
      this.builder.renderTopNav(true);
      this.builder.renderArrows();
      this.querySelectorAll('input[data-name*="items"]').forEach(input => {
        if(input.dataset.name) {
          input.setAttribute('name', input.dataset.name);
          input.removeAttribute('data-name');
        }
      })
      return;  
    }
    this.classList.add('hide');
    this.querySelectorAll('input[name*="items"]').forEach(input => {
      input.setAttribute('data-name', input.name);
      input.removeAttribute('name');
    })
    this.querySelectorAll('.step').forEach(step => {
      step.setAttribute('data-not-required', true)
      step.classList.add('no-step');
    });
    this.builder.updateStepsData()
    this.builder.renderTopNav(true);
    this.builder.renderArrows();
  }

  refreshComponent(variant, hideSetOptions){
    
    this.previousVariant = variant;
    this.setAttribute('data-price', 0);
    var optionValues = this.getOptionValues(variant);
    this.tiedProductData.options.forEach((option, i)=>{
      this.buildOptions(optionValues[i], null, hideSetOptions);  
    })
    
    // Resetting selected labels
    this.querySelectorAll('.option-name .option-value').forEach(span => span.innerHTML = '')
    
    this.querySelectorAll('[type="radio"]').forEach(radio=>{
      var options = ['option1', 'option2', 'option3'];
      var optionNumber = radio.closest('.product-swatch').dataset.option/1;
      var label = radio.parentNode.querySelector('.label-inner');
      var imgOption = options.splice(optionNumber -1, 1);

      var matchingOptionVariant = this.tiedProductData.variants.find(v=>v[imgOption]==radio.value && v[options[0]]==variant[options[0]] && v[options[1]]==variant[options[1]]);
      if (!matchingOptionVariant) {
        matchingOptionVariant = this.tiedProductData.variants.find(v=>v[imgOption]==radio.value);
      }
      
      var img = label.querySelector('img');
      if(img){
        img.remove();
      }

      if (matchingOptionVariant.featured_image) {
          img = document.createElement('img');
          img.classList.add('swatch-image', 'lazyload');
          img.setAttribute('data-srcset', $s.buildImgSrcset(matchingOptionVariant.featured_image.src, {width: 50, height: 50}));
          img.setAttribute('alt', matchingOptionVariant.featured_image.alt);
          img.src = $s.imgUrlFilter(matchingOptionVariant.featured_image.src, '80x');
          label.insertAdjacentElement('afterbegin', img);
          label.closest('.swatch').classList.add('image-swatch');
          return;
      }

      label.closest('.swatch').classList.remove('image-swatch');

    });
  }

  connectedCallback() {
    this.setAttribute('data-loaded', 'true'); // Mark as loaded
    this.dispatchEvent(new CustomEvent('childElementLoaded', { bubbles: true, detail: {element: this}}));
  }

  bindOptions() {
    this.optionsElements.forEach((element)=>{
      element.addEventListener('change', (e)=>{
        let optionIdx = element.dataset.option-1;
        let variant = this.calculateNewVariant(optionIdx, e.target.value);
        this.setAttribute('data-price', variant.price);
        this.refreshOptions(element.dataset.option-1, variant);
        this.variantChange(variant);
        var tiedProductsSelectedOptionsValues = [];
        this.builder.querySelectorAll('tied-product').forEach((tiedProduct)=>{
          tiedProduct.optionsElements.forEach((el)=>{
            if(el.querySelector('.option-value').innerHTML=='') {
              return;
            }
            tiedProductsSelectedOptionsValues.push(el.querySelector('.option-label').innerHTML+el.querySelector('.option-value').innerHTML);
          });
          
        });

        if(this.tiedProductData.variantMapping){
          this.handleVariantMapping(variant);
        }

        this.tiedProductsSelectedOptionsValues = tiedProductsSelectedOptionsValues.filter(item => item != '');
        //console.log(this.tiedProductsSelectedOptionsValues);
        this.builder.dispatchEvent(new CustomEvent('tiedProductVariantChange', {detail: {variant: variant, element: this}}));
        this.builder.dispatchEvent(new CustomEvent('stepChange', {detail: {}}));
      });
    });
  }

  handleVariantMapping(variant) {
    var variantMapping = this.tiedProductData.variantMapping[variant.id];
    if(variantMapping) {
      var childTiedComponent = this.builder.querySelector('tied-product[data-product-id="'+variantMapping.productChildId+'"]');
      this.tiedProductChild = childTiedComponent;
      
      if(!this.tiedProductChild) return;

      // show only variants from the variantMapping.variants
      var childVariants = this.tiedProductChild.tiedProductData.variants.filter((childVariant)=>{
        return (variantMapping.variantsAsObjects) ? variantMapping.variants.find(v => v.id==childVariant.id) : variantMapping.variants.includes(childVariant.id);;
      });
      
      if(childVariants.length <= 0) return;
      this.tiedProductChild.currentVariant = childVariants[0];
      this.tiedProductChild.value = childVariants[0].id;
      this.tiedProductChild.tmpVariants = childVariants;
      this.tiedProductChild.refreshComponent(childVariants[0]);
      return;
    }
    if(this.tiedProductChild){
      var mainProductVariant = this.builder.getCurrentVariant();
      if(mainProductVariant) {
        this.tiedProductChild.tmpVariants = this.tiedProductChild.tiedProductData.variants;
        //refresh tied products components
        this.tiedProductChild.refreshComponent(mainProductVariant)
      }
    }
  }

  hideMediaFromOtherProducts() {
    if(this.mainGallery) {
      this.mainGallery.querySelectorAll('[data-product-id="'+ this.dataset.productId +'"]').forEach((item)=>{
        item.style.display = 'none';
      });
      if(this.mainGallery.slider) {
        this.mainGallery.slider.refresh();
      }
    }
    if(this.mainGalleryThumbs) {
      this.mainGalleryThumbs.querySelectorAll('[data-product-id="'+ this.dataset.productId +'"]').forEach((item)=>{
        item.style.display = 'none';
      });
      if(this.mainGalleryThumbs.slider) {
        this.mainGalleryThumbs.slider.refresh();
      }
    }
  }

  refreshOptions(updateOptionIndex=-1, currentVariant) {
    var optionValues = this.getOptionValues(currentVariant);
    this.optionsElements.forEach((element)=>{
      let index = element.dataset.option - 1;
      if(index > updateOptionIndex) {
        element.buildOptions(optionValues[index], currentVariant.options[index]);
      }
      var optionValueElement = element.querySelector('.option-value');
      if(optionValueElement) {
        optionValueElement.innerHTML = currentVariant.options[index];
      }
    });
  }

  variantChange(variant, animate=true) {
    if(variant) {
      this.variantInput.value = variant.id;
    } else {
      this.variantInput.value = '';
    }
    this.previousVariant = variant;
    
    this.variantInput.dispatchEvent(new Event('change', {bubbles: true}))
  }

  getMatchingVariant(mainProductVariant) {
    var matchingVariants = this.tiedProductData.variants.filter(v => {
      var matches = 0;
      this.commonOptions.forEach((option, i)=>{
        if(v['option'+(i+1)]==mainProductVariant['option'+(i+1)]) {
          matches++;
          return;
        }
      })
      return matches==this.commonOptions.length;
    })
    
    return matchingVariants;
  }

  calculateNewVariant(optionChanged, value) {
    var newVariants = this.tmpVariants;
    this.tiedProductData.options.forEach((option, index)=>{
      if(optionChanged==index) {
        newVariants = newVariants.filter(x=>x.options[index]==value);
      } else {
        var tmpNewVariants = newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]);
        if(tmpNewVariants.length==0) {
          tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
        }
        newVariants = tmpNewVariants;
      }
    });
    return newVariants[0];
  }
    
  buildOptionsSelectors() {

    this.tiedProductData.options.forEach((option, i)=>{
      var optionElement = document.createElement('div');
      var currentVariant = this.getCurrentVariant();
      var optionValues = this.getOptionValues(currentVariant)[i];
      this.setAttribute('aria-labelledby', `tiedproduct-option-${$s.handleize(option)}-${this.builder.sectionId}`);
      optionElement.classList.add('option');

      if(!this.options.includes(option)) {
        return;
      }

      optionElement.innerHTML = `
      <div class="product-swatch step" data-option="${i+1}" data-label="${option}" id="tiedproduct-option-${$s.handleize(option)}-${this.id}">
        <span class="option-title" id="${this.getAttribute('aria-labelledby')}">${this.label}</span>
        <div class="flex justify-content-between">
          <div class="option-name">
            <span class="option-label">${option}:</span> 
            <span aria-hidden="true" class="option-value"></span>
          </div>
          <div class="swatch-group flex flex-wrap"></div>
        </div>
      </div>
      `;
      this.appendChild(optionElement);
      this.buildOptions(optionValues, null, true);
    });

  }

  buildOptions(options, defaultValue, hideSetOptions) {
    if (!options) return;
    var html = '';
    if (options.length > 0) {
      this.setAttribute('role', 'radiogroup');
    }
    options.forEach((option, index)=>{
      
      if(hideSetOptions && option.value.indexOf(this.hideVariantNameSuffix)>=0){
        return;
      }
      
      if(!this.options.includes(option.name)) {
        return;
      }

      var optionNameHandle = $s.handleize(option.name);
      var optionValueHandle = $s.handleize(option.value);
      var id = `swatch-${index+1}-${$s.handleize(option.value)}-${this.id}`;
      var soldOut = (!option.available ? '<span class="visually-hidden"> (Sold Out)</span>' : '');

      html += `
        <div class="swatch" data-available="${option.available}">
          <input type="radio" id="${id}" name="swatch-${optionNameHandle}-${this.id}" value="${$s.escapeDomAttribute(option.value)}" />
          <label for="${id}">
            <div class="label-inner flex align-items-center justify-content-center animation ${optionNameHandle}-${optionValueHandle}">
              <span>${option.value}${soldOut}</span>
            </div>
          </label>
        </div>
      `;
      var group = this.querySelector(`#tiedproduct-option-${optionNameHandle}-${this.id} .swatch-group`);
      group.innerHTML = html;
      
    });

    
  }

  getCurrentVariant() {
    return this.tmpVariants.find(x=>x.id==this.variantInput.value)
  }

  getOptionValues(currentVariant) {
    var options = [];
    if (!currentVariant) return options;
    this.tiedProductData.options.forEach((option, index)=>{
      if(index==0) {
        var optionValues = this.tmpVariants.map((variant)=>{return {
          name: this.tiedProductData.options[index],
          value: variant.options[index],
          available: variant.available
        }});
      }
      if(index==1) {
        var optionValues = this.tmpVariants.filter(x=>x.options[0]==currentVariant.option1).map((variant)=>{return {
          name: this.tiedProductData.options[index],
          value: variant.options[index],
          available: variant.available
        }});
      }
      if(index==2) {
        var optionValues = this.tmpVariants.filter(
          x=>x.options[0]==currentVariant.option1 && x.options[1]==currentVariant.option2
        ).map((variant)=>{return {
          name: this.tiedProductData.options[index],
          value: variant.options[index],
          available: variant.available
        }});
      }
      var optionValuesUnique = [];
      optionValues.forEach((option, key)=>{
        if(!optionValuesUnique.find(x=>x.value==option.value)) {
          if(option.available) {
            optionValuesUnique.push(option);
          } else {
            if(!optionValues.find((x,y)=>y!=key && x.available && x.value==option.value)) {
              optionValuesUnique.push(option);
            }
          }
        }
      });
      options.push(optionValuesUnique);
    });
    return options;
  }
    
}
customElements.define('tied-product', TiedProduct);

class PropertyOptions extends HTMLElement {
  constructor() {
    super();
    this.builder = this.closest('product-main-builder');
    this.options = JSON.parse(this.querySelector('[type="application/json"][data-property-options-json]').textContent);
    this.input = this.querySelector('[type="hidden"]');
    this.label = this.dataset.label;
    this.mainProductData = JSON.parse(this.builder.querySelector('[type="application/json"][data-product-json]').textContent);
    this.mainProductOptions = this.mainProductData.options;
    
    this.buildOptionsSelector();

    this.builder.addEventListener('mainVariantChange', (e)=>{
      this.querySelectorAll('.option-name .option-value').forEach(span => span.innerHTML = '');
      this.buildOptions(e.detail.variant);
    });

  }

  connectedCallback() {
      
    //console.log(`PropertyOptions (${this.id}) loaded`);
    this.setAttribute('data-loaded', 'true'); // Mark as loaded
    this.dispatchEvent(new CustomEvent('childElementLoaded', { bubbles: true }));
    
  }

  buildOptionsSelector() {

      this.setAttribute('aria-labelledby', `property-option-${$s.handleize(this.label)}-${this.builder.sectionId}`);
      var optionElement = document.createElement('div');
      optionElement.classList.add('option');
      optionElement.innerHTML = `
      <div class="product-swatch" data-original-label="${this.label}" id="property-option-${$s.handleize(this.label)}-${this.builder.sectionId}">
          <span class="option-title" id="${this.getAttribute('aria-labelledby')}">${this.label}</span>
          <div class="flex justify-content-between">
          <div class="option-name">
              <span class="option-label">${this.label}:</span> 
              <span aria-hidden="true" class="option-value"></span>
          </div>
          <div class="swatch-group flex flex-wrap"></div>
          </div>
      </div>
      `;
      this.appendChild(optionElement);
      this.buildOptions(this.builder.getCurrentVariant());

  }

  buildOptions(variant) {
    var html = '';
    if (this.options.length > 0) {
      this.setAttribute('role', 'radiogroup');
    }

    this.options.forEach((option, index)=>{

      if(!this.validateVariantOption(variant, option.option_value_map)) return;

      var optionNameHandle = $s.handleize(this.label);
      var optionValueHandle = $s.handleize(option.value);
      var id = `swatch-${index+1}-${$s.handleize(option.value)}-${this.builder.sectionId}`;
      var soldOut = (!option.available ? '<span class="visually-hidden"> (Sold Out)</span>' : '');
      var imageUrl = option.image;
      var imageWidth = option.image_width;
      var imageHeight = option.image_height;
      if(imageUrl){
          var img = document.createElement('img');
          img.classList.add('swatch-image', 'lazyload');
          img.setAttribute('data-srcset', $s.buildImgSrcset(imageUrl, {width: 50, height: 50}));
          img.setAttribute('width', imageWidth);
          img.setAttribute('height', imageHeight);
          img.setAttribute('alt', option.title);
      }
      html += `
        <div class="swatch ${img ? 'image-swatch' : ''}" data-available="${option.available}">
          <input type="radio" id="${id}" name="property-${optionNameHandle}-${this.builder.sectionId}" value="${$s.escapeDomAttribute(option.value)}" />
          <label for="${id}">
            <div class="label-inner flex align-items-center justify-content-center animation ${optionNameHandle}-${optionValueHandle}">
              <span class="${img ? 'visually-hidden' : ''}">${option.value}${soldOut}</span>
              ${img ? img.outerHTML : ''}
            </div>
          </label>
        </div>
      `;
    });
    var group = this.querySelector('.swatch-group');
    group.innerHTML = html;
    this.bindOptions();
  }

  bindOptions() {
    this.querySelectorAll('input').forEach((input)=>{
      input.addEventListener('change', (e)=>{
          var optionValueElement = this.querySelector('.option-value');
          if(optionValueElement) {
              optionValueElement.innerHTML = input.value;
              this.input.value = input.value;
              this.builder.dispatchEvent(new CustomEvent('stepChange', {detail: {}}));
          }
      });
    });
  }

  validateVariantOption(variant, optionMaps) {
    var matches = 0;

    optionMaps.forEach((option)=>{
      var optionKey = Object.keys(option)[0];
      var optionValue = Object.values(option)[0];
      var optionIndex = this.mainProductOptions.findIndex(x=>x==optionKey);

      if(optionValue.includes(variant.options[optionIndex])) {
        matches++;
      }
      
    });
    return matches==optionMaps.length;
  }

}
customElements.define('property-options', PropertyOptions);

if(!customElements.get('builder-buttons')) {
  class BuilderButtons extends HTMLElement {
      constructor() {
      super();
      this.builder = this.closest('product-main-builder');
      this.mainAddButton = this.builder.querySelector('button.add');
      this.feedbackMessage = this.builder.querySelector('.feedback-msg')
      this.button = this.querySelector('.btn');
      this.missingValues = [];
      
      this.button.addEventListener('click', (event)=>{
        event.preventDefault();
        event.stopImmediatePropagation();
        if(this.validate()) {
          this.builder.addRecommendedProducts(()=>{
            this.builder.querySelector('add-to-cart-form').submit();
          });
        }
      });
        

      this.refresh();
    }

    refresh() {
      var requiredBtn = this.querySelector('.btn.selection-required');
      this.missingValues = [];
      this.feedbackMessage.classList.add('hide');
      this.builder.stepsData.forEach((step)=>{
          this.builder.querySelector(`[data-step="${step.step_number}"]`)?.classList.remove('error');
          this.builder.querySelector(`[data-step-nav="${step.step_number}"]`)?.classList.remove('error');
          if(step.values.length == 0 && !step.notRequired) {
            this.missingValues.push(step);
          }
          if(step.values.length > 0 && !step.notRequired) {
              step.values.forEach((value)=>{
                  if(!value.notRequired && value.value.length == 0 || value.value == 'Unselected') {
                    this.missingValues.push(step);
                  }
              });
          }
      })

      this.builder.querySelectorAll('tied-product').forEach((tiedProduct)=>{
        if(tiedProduct.getCurrentVariant() && tiedProduct.getCurrentVariant().available) {
          this.missingValues = this.missingValues.filter(x=>x!=tiedProduct);
        }
      });

      if (this.missingValues.length > 0) {
        this.querySelector('.btn').classList.add('disabled');
        //this.feedbackMessage.classList.remove('hide');
        if (requiredBtn) requiredBtn.style.display = 'none';
      }else {
        this.querySelector('.btn').classList.remove('disabled');
        if (requiredBtn) requiredBtn.style.display = 'none';
        //this.feedbackMessage.classList.add('hide');
      }
    }

    validate() {
      this.refresh();
        
      if (this.missingValues.length > 0) {
        this.missingValues.forEach((step)=>{
          this.builder.querySelector(`[data-step="${step.step_number}"]`).classList.add('error');
          this.builder.querySelector(`[data-step-nav="${step.step_number}"]`).classList.add('error');
        });
        this.feedbackMessage.classList.remove('hide');

        var firstError = this.builder.querySelector(`.step[data-step="${this.missingValues[0].step_number}"]`);
        if (firstError) {
          firstError.scrollIntoView({behavior: "smooth", block: "center"});
        }

        return false;
      }
      this.feedbackMessage.classList.add('hide');
      return true;
    }

  }
  customElements.define('builder-buttons', BuilderButtons);
}

class ProductBundlePrice extends HTMLElement {
  constructor() {
  super();
  this.mainElement = this.closest('product-main-builder');
  this.listenEvents = ['priceChange', 'bundleChange', 'mainVariantChange', 'tiedProductVariantChange'];
  this.comparePrice = this.querySelector('.compare');
  this.finalPrice = this.querySelector('.final');
  let mainPrice = 0;
  this.listenEvents.forEach((event)=>{
    this.mainElement.addEventListener(event, (e)=>{
      mainPrice = this.mainElement.getCurrentVariant().price;
      let totalPrice = mainPrice;
      let isBundle = false;
      this.mainElement.querySelectorAll('[data-price]').forEach((el)=>{
        const quantityInput = el.querySelector('[name*="[quantity]');
        if (!quantityInput) return;
        const quantity = quantityInput.value/1;

        totalPrice += el.dataset.price/1 * quantity;
        
        isBundle = true;
      })

      const discountMultiplier = isBundle ? 1 - (this.dataset.discountPercentage||0)/100 : 1;
      if (discountMultiplier==1) {
        this.comparePrice.style.display = 'none';
      } else {
        this.comparePrice.style.display = '';
      }

      this.comparePrice.innerHTML = $s.formatMoney(totalPrice).replace('.00', '');
      this.finalPrice.innerHTML = ' | '+$s.formatMoney(totalPrice * discountMultiplier).replace('.00', '');

      if (isBundle) {
        this.classList.add('is-bundle');
      } else {
        this.classList.remove('is-bundle');
      }
    });
  });
}
}
customElements.define('product-bundle-price', ProductBundlePrice);

if(!customElements.get('gift-message')) {
class GiftMessage extends HTMLElement {
  constructor() {
    super();
    this.builder = this.closest('product-main-builder');
    this.messageInput = this.querySelector('textarea');
    this.messageLabel = this.querySelector('.gift-message-input label');
    this.requestInputs = this.querySelectorAll('[type="radio"]');
    this.isGift = false;
    this.customizationsAsCartNote = this.dataset.customizationsAsCartNote === 'true';
    
    this.messageInput.addEventListener('keyup', this.onMessageChange.bind(this));
    if (this.requestInputs) {
      this.requestInputs.forEach((input) => {
        input.addEventListener('change', this.onRequestChange.bind(this));
      })
      this.updateMessageInput([...this.requestInputs].find(input => input.checked));
    }
    // This line includes customizations as a cart note
    if (this.customizationsAsCartNote) {
      window.addEventListener('cart:added', event => {
        $s.post({
          type: 'POST', 
          url: routes.cart_url + '/update.js', 
          data: {
            note: `${(this.isGift) ? this.messageInput.dataset.giftNotesTitle : this.messageInput.dataset.notesTitle}: ${this.messageInput.value}`, dataType: 'json'
          }
        });
      })
    }
  }

  updateMessageInput(status) {
    this.messageInput.disabled = !status;
    this.messageLabel.classList.toggle('hide', !status);
    
    if (status != lngg.product_main__builder__builder_is_gift_label) { 
      this.messageInput.value = '';
      this.messageInput.setAttribute('data-required', false);
      this.messageLabel.textContent = lngg.product_main__builder__builder_not_gift_message_label;
      this.isGift = false;
    } else {
      this.messageInput.setAttribute('data-required', true);
      this.messageLabel.textContent = lngg.product_main__builder__builder_is_gift_message_label;
      this.isGift = true;
    }
  }

  onRequestChange(e) {
    this.updateMessageInput(e.target.value);
    this.builder.dispatchEvent(new CustomEvent('stepChange', {detail: {}}));
  }

  onMessageChange(e) {
    if(this.messageInput.value.length <= 0) {
      this.messageInput.removeAttribute('name');
      return;
    }
    this.messageInput.setAttribute('name', this.messageInput.dataset.name);
    this.builder.dispatchEvent(new CustomEvent('stepChange', {detail: {}}));
  }
}
customElements.define('gift-message', GiftMessage);
}